module.exports = __webpack_public_path__ + "verkocht1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/verkocht1.jpg
// module id = 633
// module chunks = 0